import React from 'react';
import { Outlet } from 'react-router-dom';

import { prefetchHomeCards } from '@/console/app/routes/root/home-card-prefetch';
import {
  MainContainer,
  RootContainer,
} from '@/console/app/routes/root/root.styled';
import { ConsoleSidebar } from '@/console/features/console-sidebar/console-sidebar';
import { FactoryOperator } from '@/console/features/factory-operator/factory-operator';
import { MaintenanceAlert } from '@/shared/components/ui/alert/variant/maintenance-alert';
import { OverlayLoader } from '@/shared/components/ui/overlay-loader/overlay-loader';
import { Header } from '@/shared/features/header/header';
import { useNavigationLoader } from '@/shared/hooks/use-navigation-loader/use-navigation-loader';
import { useUiPreferencesSync } from '@/shared/hooks/use-ui-preferences-sync/use-ui-preferences-sync';
import { selectUser } from '@/shared/redux/api/auth/auth-api';
import { identApi } from '@/shared/redux/api/ident/ident-api';
import store from '@/shared/redux/store/store';

export const rootLoader = async () => {
  const user = selectUser(store.getState());

  if (!user) {
    return null;
  }

  void store.dispatch(identApi.endpoints.ReadTenant.initiate());
  void store.dispatch(identApi.endpoints.ReadUserUiPreferences.initiate());
  prefetchHomeCards();
  return null;
};

export const AppRoot = () => {
  const displayNavigationLoader = useNavigationLoader();
  useUiPreferencesSync();

  return (
    <RootContainer>
      <ConsoleSidebar />
      <MainContainer>
        <OverlayLoader display={displayNavigationLoader} />
        <Header />
        <MaintenanceAlert />
        <FactoryOperator />
        <Outlet />
      </MainContainer>
    </RootContainer>
  );
};
